// Generated types for TaskNode
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { IslandRootReadAPI, IslandRootWriteAPI } from '../../shared/types/islandroot';
import { IslandRootReadAPISchemaObject, IslandRootWriteAPISchemaObject } from '../../shared/types/islandroot';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface TaskNodeReadAPI extends IslandRootReadAPI {
  name: string;
  description?: string | null;
  status: "created" | "running" | "paused" | "done" | "error" | "timeout" | "canceled" | "interrupted";
  priority?: number;
  parent_task_id?: string | null;
  tool_call_id?: string | null;
  deferred_tool_calls?: string | null;
  /** Approval responses for deferred tool calls */
  deferred_responses?: string | null;
  /** Versioning lane this task's content edits are booked on (the launching user's overlay, or the task's own proposal). */
  edit_lane?: string | null;
  /** Runs in the background: edits go to the task's own proposal overlay instead of the launching user's. */
  background?: boolean;
  /** User-selected model for this chat: 'primary' | 'backup' */
  model_preference?: "primary" | "backup" | null;
  model_reason?: "chosen" | "default" | "fallback" | "switched" | null;
  model_stalled?: string | null;
  model_stalled_at?: number | null;
  active_skill_name?: string | null;
  model_name?: string | null;
  temperature?: number;
  top_p?: number | null;
  max_tokens?: number | null;
  timeout?: number | null;
}

export interface TaskNodeWriteAPI extends IslandRootWriteAPI {
  /** Approval responses for deferred tool calls */
  deferred_responses?: string | null;
  /** Runs in the background: edits go to the task's own proposal overlay instead of the launching user's. */
  background?: boolean;
  /** User-selected model for this chat: 'primary' | 'backup' */
  model_preference?: "primary" | "backup" | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const TaskNodeReadAPISchemaObject = IslandRootReadAPISchemaObject.extend({
  name: z.string(),
  description: z.string().nullable().optional(),
  status: z.enum(["created", "running", "paused", "done", "error", "timeout", "canceled", "interrupted"]),
  priority: z.number().optional(),
  parent_task_id: z.string().nullable().optional(),
  tool_call_id: z.string().nullable().optional(),
  deferred_tool_calls: z.string().nullable().optional(),
  deferred_responses: z.string().nullable().optional(),
  edit_lane: z.string().nullable().optional(),
  background: z.boolean().optional(),
  model_preference: z.enum(["primary", "backup"]).nullable().optional(),
  model_reason: z.enum(["chosen", "default", "fallback", "switched"]).nullable().optional(),
  model_stalled: z.string().nullable().optional(),
  model_stalled_at: z.number().nullable().optional(),
  active_skill_name: z.string().nullable().optional(),
  model_name: z.string().nullable().optional(),
  temperature: z.number().optional(),
  top_p: z.number().nullable().optional(),
  max_tokens: z.number().nullable().optional(),
  timeout: z.number().nullable().optional(),
}).passthrough();
export const TaskNodeReadAPISchema: z.ZodType<TaskNodeReadAPI> = TaskNodeReadAPISchemaObject;

export const TaskNodeWriteAPISchemaObject = IslandRootWriteAPISchemaObject.extend({
  deferred_responses: z.string().nullable().optional(),
  background: z.boolean().optional(),
  model_preference: z.enum(["primary", "backup"]).nullable().optional(),
}).passthrough();
export const TaskNodeWriteAPISchema: z.ZodType<TaskNodeWriteAPI> = TaskNodeWriteAPISchemaObject;
